import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}
export function Card({
  className,
  ...props
}: CardProps) {
  return <div className={cn('rounded-xl border border-slate-200 bg-white text-slate-950 shadow-sm', className)} {...props} data-id="element-297" />;
}
export function CardHeader({
  className,
  ...props
}: CardProps) {
  return <div className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} data-id="element-298" />;
}
export function CardTitle({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-semibold leading-none tracking-tight text-slate-900', className)} {...props} data-id="element-299" />;
}
export function CardContent({
  className,
  ...props
}: CardProps) {
  return <div className={cn('p-6 pt-0', className)} {...props} data-id="element-300" />;
}